export enum ENROLLMENT_FLOW {
    OEP = 'OEP',
    SEP_PAPER = 'sepPaper',
    SEP_ELECTRONIC = 'sepElectronic',
    DENTAL = "Dental"
}
  